/**
 * UTM parameters from the CURRENT PAGE url.
 *
 * These live in the browser address bar (the ad's landing URL), not on the
 * API request the page makes — so unless we forward them explicitly the
 * server records a visit with no idea which campaign produced it, which is
 * most of the value of counting visits at all.
 *
 * Forwarded on the config request as query params, alongside the visitor id
 * header, so no extra round trip is introduced.
 */
export const currentUtmParams = () => {
  try {
    const params = new URLSearchParams(window.location.search);
    const out = {};
    params.forEach((value, key) => {
      if (key.startsWith("utm_") && value) out[key] = value;
    });
    return out;
  } catch {
    // Never let attribution break a page load.
    return {};
  }
};

/** `?utm_source=…&utm_campaign=…`, or "" when there are none. */
export const utmQueryString = () => {
  const utm = currentUtmParams();
  const keys = Object.keys(utm);
  if (!keys.length) return "";
  return new URLSearchParams(utm).toString();
};
